import request from "@/utils/request";

export function getApiUsageDaily(data, signal) {
  return request({
    url: "/api_keys/usage/daily",
    method: "post",
    data,
    signal,
  });
}

export function getApiUsageBreakdown(data, signal) {
  return request({
    url: "/api_keys/usage/breakdown",
    method: "post",
    data,
    signal,
  });
}
